import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Sidebar from './Sidebar.jsx';
import TopNavigation from './TopNavigation.jsx';
import Footer from './Footer.jsx';
import {Navigate, useLocation} from "react-router-dom";

const MainLayout = ({children}) => {
	
	const theme = document.documentElement.dataset.theme;
	const settings = useSelector((state) => state.settings);
	const [sidebarStatus, SetSidebarStatus] = useState(settings.sidebar);
	const token = localStorage.getItem("token");
	const location = useLocation();

	useEffect(() => {
		if(window.innerWidth < 768)
		{
			SetSidebarStatus('collapse');
		}
	}, [location]);

	const HamburgerClick = () => {
		const newStatus = sidebarStatus === 'collapse' ? 'expand' : 'collapse';
		SetSidebarStatus(newStatus);
	}

	const host = window.location.host;
	const safeArea = (host.split('.')[0] === 'mobile' && window.innerWidth < 640) ? '40px' : '0';
	if (!token || token === '')
	{
		return <Navigate to="/login"/>
	}
	return(
		<div className="App bg-gradient-to-tr from-bodyBGFrom to-bodyBGTo" style={{paddingTop: safeArea}}>
			<div className="relative flex gap-3 min-h-screen">
				<div className={(sidebarStatus === 'collapse' ? 'hidden' : 'md:hidden fixed w-full h-screen z-20 bg-black/40')} onClick={HamburgerClick}></div>
				<Sidebar status={sidebarStatus} HamburgerClick={HamburgerClick}/>
				{theme === "Default" ?
				<div className="flex flex-col grow !m-0 min-w-[16rem] pb-0 content min-h-screen rounded-none">
					<div className="relative ">
						<main className="">
							<TopNavigation sidebarStatus={sidebarStatus} HamburgerClick={HamburgerClick}/>
							{children}
						</main>
					</div>
					<Footer/>
				</div>
				:
				<div className="flex flex-col grow !m-0 min-w-[16rem] p-4 pb-0 min-h-screen">
					<TopNavigation sidebarStatus={sidebarStatus} HamburgerClick={HamburgerClick}/>
					<div className="relative mt-12 md:mt-5 ">
						<div className='layers relative z-10'></div>
						<main className="content">
							{children}
						</main>
					</div>
					<Footer/>
				</div>}
			</div>
		</div>
	);
}

export default MainLayout;